$(document).ready(function(){
 $(".blogs__slider").owlCarousel({
      nav:true,
      items:5
   })
  const showMoreBtn = document.querySelector(".load__more");
  const items = document.querySelectorAll(".blog-post-card");
  let visibleItemCount = 4;

  showMoreBtn.addEventListener("click", function () {
    for (let i = visibleItemCount; i < visibleItemCount + 3; i++) {
      if (i < items.length) {
        items[i].style.display = "block";
      }
    }
    visibleItemCount += 3;

    if (visibleItemCount >= items.length) {
      showMoreBtn.style.display = "none";
    }
  });
})